/**
 * Cobro de la suscripción con tarjeta: cuánto se cobra (precio + IVA) y quién puede pagar qué.
 */
export const IVA_SUSCRIPCION = 15;

export interface MontosTarjeta { base: number; iva: number; total: number }

/** Precio sin IVA (en centavos) → precio, IVA y total a cobrar (en centavos). */
export function montosTarjeta(base: number, tasa = IVA_SUSCRIPCION): MontosTarjeta {
  const iva = Math.round((base * tasa) / 100);
  return { base, iva, total: base + iva };
}

export type EstadoSuscripcion = "prueba" | "activa" | "gracia" | "vencida" | "suspendida";

/**
 * ¿Puede la clínica pagar este plan con tarjeta ahora?
 * Sí: renovar su plan actual (también cambiando de mensual a anual), y elegir cualquier plan en la prueba, en la gracia o con la suscripción vencida.
 * No: cambiar a otro plan mientras tiene tiempo pagado (habría que descontar lo ya pagado: lo ve el equipo de Donna) ni con la cuenta suspendida.
 */
export function puedePagarConTarjeta(estado: EstadoSuscripcion, planActual: string, planElegido: string): { ok: boolean; motivo: string } {
  if (estado === "suspendida") return { ok: false, motivo: "La cuenta de tu clínica está suspendida: comunícate con Donna para reactivarla." };
  if (planElegido === planActual) return { ok: true, motivo: "" };
  if (estado === "activa") return { ok: false, motivo: "Para cambiar de plan mientras tienes tiempo pagado, comunícate con Donna: así se descuenta lo que ya pagaste." };
  return { ok: true, motivo: "" };
}
